import {
    MapPin,
    Wrench,
    CurrencyDollar,
    ClipboardText,
    ShieldCheck,
    Plant,
} from "@phosphor-icons/react";
import { Chapter, Reveal } from "@/components/site/Reveal";

const ITEMS = [
    {
        icon: MapPin,
        title: "Locally owned",
        desc: "Born and based in the Treasure Valley. We know Idaho dirt, sun, and snow.",
    },
    {
        icon: Wrench,
        title: "Pro installation",
        desc: "Hand-laid by a vetted in-house crew — no subcontractors, no shortcuts.",
    },
    {
        icon: CurrencyDollar,
        title: "Honest pricing",
        desc: "Flat quotes, no surprises. We'll walk you through every line item.",
    },
    {
        icon: ClipboardText,
        title: "Free estimates",
        desc: "On-site measurement and consultation, zero obligation, always free.",
    },
    {
        icon: ShieldCheck,
        title: "16-year warranty",
        desc: "Backed by manufacturer warranty and our local workmanship guarantee.",
    },
    {
        icon: Plant,
        title: "Eco-friendly",
        desc: "Save 50,000+ gallons of water a year per average lawn. No pesticides, ever.",
    },
];

export const WhyChoose = () => {
    return (
        <section
            id="why"
            data-testid="why-section"
            className="relative border-t border-brand-border/60 bg-white py-24 md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <Chapter
                    index="02"
                    label="Why us"
                    testid="why-chapter"
                    title={
                        <>
                            Six reasons our neighbors{" "}
                            <span className="italic text-brand-accent">keep referring us</span>.
                        </>
                    }
                    copy="We're not a national chain. We're a local crew that shows up on time, lays turf we'd lay in our own yard, and stands behind every seam."
                />

                <div className="grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-brand-border bg-brand-border sm:grid-cols-2 lg:grid-cols-3">
                    {ITEMS.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <Reveal
                                key={it.title}
                                delay={i * 0.05}
                                y={16}
                                className="h-full"
                            >
                                <div
                                    data-testid={`why-card-${i}`}
                                    className="group relative h-full bg-white p-7 transition-colors duration-500 hover:bg-brand-pine"
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="grid h-11 w-11 place-items-center rounded-xl bg-brand-accent/10 ring-1 ring-brand-accent/30">
                                            <Icon
                                                size={22}
                                                weight="duotone"
                                                className="text-brand-accent"
                                            />
                                        </div>
                                        <span className="font-display text-sm italic text-brand-muted/50">
                                            0{i + 1}
                                        </span>
                                    </div>
                                    <h3 className="font-display mt-6 text-xl font-medium text-brand-text">
                                        {it.title}
                                    </h3>
                                    <p className="mt-2 text-sm leading-relaxed text-brand-muted">
                                        {it.desc}
                                    </p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
